import { Directive, EventEmitter, HostListener, Output } from "@angular/core";

@Directive({
  selector: "[appLowercase]",
})
export class LowercaseDirective {
  @Output() ngModelChange: EventEmitter<any> = new EventEmitter();
  value: any;

  @HostListener("input", ["$event"])
  onInputChange($event) {
    this.value = $event.target.value.toLowerCase();
    this.ngModelChange.emit(this.value);
  }
}



// WEBPACK FOOTER //
// /agir/src/app/directives/lowercase.directive.ts